import React from 'react';
import PropTypes from 'prop-types';
import Table from 'antd/lib/table';
import { formatDateTimeIn } from './usageModel';

const columns = [
  {
    title: 'Kto',
    key: 'viewer',
    render: (text, entry) => (
      <div>
        <div>{entry.viewerName}</div>
        <div className="phone-usage__hint phone-usage__mono">{entry.viewerId}</div>
      </div>
    ),
  },
  {
    title: 'Pôžička',
    dataIndex: 'loanId',
    key: 'loanId',
    render: id => <span className="phone-usage__mono">{id}</span>,
  },
  {
    title: 'Snímka',
    dataIndex: 'snapshotId',
    key: 'snapshotId',
    render: id => <span className="phone-usage__mono">{id}</span>,
  },
  {
    title: 'Kedy otvorené',
    dataIndex: 'openedAt',
    key: 'openedAt',
    render: openedAt => formatDateTimeIn(openedAt),
  },
];

const byOpenedAtDesc = (a, b) => (a.openedAt < b.openedAt ? 1 : a.openedAt > b.openedAt ? -1 : 0);

const PhoneUsageAuditLog = ({ entries }) => (
  <section className="phone-usage__audit" aria-labelledby="phone-usage-audit-title" data-testid="phone-usage-audit">
    <h4 className="phone-usage__audit-title" id="phone-usage-audit-title">
      Záznam zobrazení snímok{' '}
      <span className="phone-usage__subtitle">(uložený na serveri, bez obsahu snímky)</span>
    </h4>
    {entries.length === 0 ? (
      <p className="phone-usage__hint" data-testid="phone-usage-audit-empty">
        Server pre túto snímku nevrátil žiadne zobrazenie.
      </p>
    ) : (
      <Table
        size="small"
        rowKey="id"
        columns={columns}
        dataSource={entries.slice().sort(byOpenedAtDesc)}
        pagination={false}
      />
    )}
  </section>
);

PhoneUsageAuditLog.propTypes = {
  entries: PropTypes.array.isRequired,
};

export default PhoneUsageAuditLog;



// WEBPACK FOOTER //
// ./src/features/loan-management/components/phone-usage/PhoneUsageAuditLog.js